import { render } from "./LesVideothequesPage.vue?vue&type=template&id=ef7b99be"
import script from "./LesVideothequesPage.vue?vue&type=script&lang=js"
export * from "./LesVideothequesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__